/** This is used to return the person or entity's name on the header */
import { Typography } from '@material-ui/core';
import { NATURAL_PERSON } from 'data-layer-cr/dist/constants/customerTypes';
import { Quotation } from 'data-layer-cr/dist/models';
import { colors } from 'design-system';
import React from 'react';
import CustomerItem from 'src/models/helperTypes/CustomerItem';

export function displayFullNameQuotation(quotation: Quotation): string {
  if (quotation.customerType === NATURAL_PERSON) {
    return `${quotation.customer.firstName} ${quotation.customer.lastName}`;
  }
  return quotation.legalEntity?.name || '';
}

export function displayFullNameCustomer(quotation: CustomerItem): string {
  if (quotation.type === NATURAL_PERSON) {
    return `${quotation.firstName} ${quotation.lastName}`;
  }
  return quotation.entityName;
}

export function displayHeaderContent(): React.ReactNode {
  return (
    <>
      <Typography
        data-testid="title-quotation"
        variant="body2"
        style={{ color: colors.white }}
      >
        Cotización
      </Typography>
      <Typography
        data-testid="title-coverage"
        variant="body2"
        style={{ color: colors.white }}
      >
        Cobertura completa
      </Typography>
    </>
  );
}
